export type UrlAuthParamName = 'token' | 'auth_token';

export const readAuthTokenFromUrl = (): { token: string | null; paramName: UrlAuthParamName | null } => {
  const urlParams = new URLSearchParams(window.location.search);

  const tokenParam = urlParams.get('token');
  if (tokenParam) {
    return { token: tokenParam, paramName: 'token' };
  }

  const authTokenParam = urlParams.get('auth_token');
  if (authTokenParam) {
    return { token: authTokenParam, paramName: 'auth_token' };
  }

  return { token: null, paramName: null };
};

export const removeAuthTokenFromUrl = (paramName: UrlAuthParamName): void => {
  const url = new URL(window.location.href);
  url.searchParams.delete(paramName);
  window.history.replaceState({}, document.title, url.toString());
};
